export function buildMediaImageLocal(el, attachment) {
  return {
    elementId: el.id,
    attachmentId: attachment?.id ?? null,
    image: attachment?.attributes ?? null
  }
}
